module.exports = __webpack_public_path__ + "02_long_black.ab45d1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/02_long_black.png
// module id = obWI
// module chunks = 0